import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const Table = props => {
  const {
    className,
    theme,
    size,
    bordered,
    striped,
    inverse,
    hover,
    tag: Tag,
    ...attributes
  } = props

  const classes = classNames(
    className,
    theme['table'],
    bordered ? theme['table-bordered'] : false,
    striped ? theme['table-striped'] : false,
    inverse ? theme['table-inverse'] : false,
    hover ? theme['table-hover'] : false,
  )

  return <Tag {...attributes} className={classes} />
}

Table.propTypes = {
  className: PropTypes.string,
  theme: PropTypes.object.isRequired,
  bordered: PropTypes.bool,
  striped: PropTypes.bool,
  inverse: PropTypes.bool,
  hover: PropTypes.bool,
  reflow: PropTypes.bool,
  responsive: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  responsiveTag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
}

Table.defaultProps = {
  tag: 'table',
}

export default Table



// WEBPACK FOOTER //
// ./ui/Table/Table.js